/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    LearningOutcomeReportRowDTO,
    LearningOutcomeReportRowDTOFromJSON,
    LearningOutcomeReportRowDTOFromJSONTyped,
    LearningOutcomeReportRowDTOToJSON,
} from './LearningOutcomeReportRowDTO';

/**
 *
 * @export
 * @interface LearningOutcomesReportProgramDTO
 */
export interface LearningOutcomesReportProgramDTO {
    /**
     *
     * @type {string}
     * @memberof LearningOutcomesReportProgramDTO
     */
    programName?: string | null;
    /**
     *
     * @type {string}
     * @memberof LearningOutcomesReportProgramDTO
     */
    facultyName?: string | null;
    /**
     *
     * @type {string}
     * @memberof LearningOutcomesReportProgramDTO
     */
    planCadru?: string | null;
    /**
     *
     * @type {Array<LearningOutcomeReportRowDTO>}
     * @memberof LearningOutcomesReportProgramDTO
     */
    rows?: Array<LearningOutcomeReportRowDTO> | null;
}

export function LearningOutcomesReportProgramDTOFromJSON(json: any): LearningOutcomesReportProgramDTO {
    return LearningOutcomesReportProgramDTOFromJSONTyped(json, false);
}

export function LearningOutcomesReportProgramDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): LearningOutcomesReportProgramDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'programName': !exists(json, 'programName') ? undefined : json['programName'],
        'facultyName': !exists(json, 'facultyName') ? undefined : json['facultyName'],
        'planCadru': !exists(json, 'planCadru') ? undefined : json['planCadru'],
        'rows': !exists(json, 'rows') ? undefined : (json['rows'] === null ? null : (json['rows'] as Array<any>).map(LearningOutcomeReportRowDTOFromJSON)),
    };
}

export function LearningOutcomesReportProgramDTOToJSON(value?: LearningOutcomesReportProgramDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'programName': value.programName,
        'facultyName': value.facultyName,
        'planCadru': value.planCadru,
        'rows': value.rows === undefined ? undefined : (value.rows === null ? null : (value.rows as Array<any>).map(LearningOutcomeReportRowDTOToJSON)),
    };
}

